import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import ToggleButton from 'react-toggle-button'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';
import { cloneDeep, isEmpty } from 'lodash';

import "./index.css";
class GroupAgentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			confirmDelete: false,
			selectedBlId: 0,
			userApiList : [],
			selecteApiKeyId : 0,
			sizePerPage: 10,
            groupAgentList : [],
            activeGroupId: null,
            selectedGroupInfo: {},
			selectedGroupId : 0,
			loading: true
		}
	}
	componentDidMount() {
		this.getGroupAgentList();
		const savedSizePerPage = Cookies.get('groupAgentListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}

	getGroupAgentList = () => {
		const apiPath = this.props.app.apiPath;
		const userId = this.props.app.userId;
		this.setState({ loading: true });
		Fetcher.get(apiPath + '/api/obd/group/agent/list/'+userId)
			.then(res => {
				this.setState({
					groupAgentList: res
				})
			})
			.catch(err => { console.log('Error in fetching Group Agent List', err) })
			.finally(() => {
				this.setState({ loading: false });
			});
	}

	confirmDelete = (status, blId) => {
		this.setState({
			confirmDelete: status,
			selectedGroupId: blId
		});
	}

	deleteGroup = () => {
		const gId = this.state.selectedGroupId;
		const data = {

		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/group/agent/' + gId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.state.confirmDelete = false;
				this.getGroupAgentList();
			})
			.catch(err => {
				console.log('Error in Deleting Group', err);
			});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('apiKeyListsizePerPage', newSizePerPage);
	}

    getAgentInfo = (gId, type) => {
		if(this.state.loading === true){
			return;
		}
		this.setState({
			...(type === 'number' && { activeGroupId: gId }),
			loading: true
		})
		const apiPath = this.props.app.apiPath;
		Fetcher.get(apiPath + '/api/obd/group/agent/' + gId)
			.then(res => {
				this.setState({
					selectedGroupInfo: res,
					loading: false
				})
			})
			.catch(err => { 
				console.log('Error in fetching Group Agent list', err) 
				this.setState({
					loading: false
				})
			});
	}

    handleDropdownToggleAction = (isOpen, type) => {
		if (!isOpen) {
			if (type === 'number') {
				this.setState({ activeGroupId: null });
			} else if (type === 'group') {
				this.setState({ activeGroupId: null });
			}
		}
	};

	render() {

		const groupAgentList = this.state.groupAgentList;
		let columns = '';
		
			columns = [
				{
				dataField: 'groupId',
				text: 'Id',
				sort: false
			},
			{
				dataField: 'groupName',
				text: 'Group Name',
				sort: false,
				searchable: true
			},
            {
				dataField: 'reqestDate',
				text: 'Request Date',
				sort: true,
				searchable: false
			},
            {
				dataField: 'agent',
				text: 'Agent Details',
				sort: false,
				searchable: false
			}, {
				dataField: 'action',
				text: 'Action',
				sort: false,
				searchable: false
			},];

		const groupagent = Array.isArray(groupAgentList) ? groupAgentList.map((blist, index) => {

			let action = [];
				action.push(<Dropdown>
					<Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
						<Dropdown.Menu>
						<Dropdown.Item key={`${index}-update-group-agent`} href={`${this.props.app.urlPrefix}/update-group-agent/${blist.groupId}`}>Edit Group</Dropdown.Item>	
					  	<Dropdown.Item key={`${index}-delete-api-key`} onClick={(e) => { this.confirmDelete(true, blist.groupId) }} href="#">Delete Group</Dropdown.Item>
						</Dropdown.Menu>
				  	</Dropdown>);

            let selectedGroupAction;
				if(this.state.activeGroupId !== blist.groupId){
					selectedGroupAction = (
						<Dropdown show={false}>
							<Dropdown.Toggle onClick={() => this.getAgentInfo(blist.groupId, 'number')} size="sm" variant="success">Agent Info</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item>
									Agent Info
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					);
				} else {
					selectedGroupAction = (
						<Dropdown show={this.state.activeGroupId === blist.groupId} onToggle={(isOpen) => this.handleDropdownToggleAction(isOpen, 'number')}>
							<Dropdown.Toggle className="btn-sm" variant="success">Agent Info</Dropdown.Toggle>
							<Dropdown.Menu>
								{isEmpty(this.state.selectedGroupInfo.agents) ? (
										<Dropdown.Item disabled>No Agent found</Dropdown.Item>
									) : (
										this.state.selectedGroupInfo.agents.map((ag, index) => (
											<Dropdown.Item key={`ag${index}`} disabled>
												{ag.agentNumber} - {ag.agentName}
											</Dropdown.Item>
										))
								)}
							</Dropdown.Menu>
						</Dropdown>
					);
				}
				
			
			return {
				groupId : blist.groupId,
				groupName: blist.groupName,
                reqestDate: blist.reqestDate,
                agent : selectedGroupAction,
				action: action
			};
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'groupId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: groupagent.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				<Card.Header>Agent Group List</Card.Header>
				<Card.Body>
					<div className="campaign-list-table-cont">
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (<ToolkitProvider keyField="groupId" data={groupagent} columns={columns} search bootstrap4>
									{props => (<div className="">
										Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
										<span className="search-cont"><SearchBar {...props.searchProps} /></span>
										<ClearSearchButton className="btn-primary" {...props.searchProps} />
										<hr />
										<BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
										<PaginationListStandalone {...paginationProps} />
									</div>)}
								</ToolkitProvider>)
							}
						</PaginationProvider>}
					</div>
					
				<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete Group
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this Group?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteGroup} variant="primary">YES</Button>
						</Modal.Footer>
				</Modal>

				{this.state.loading && <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>}
				</Card.Body>
			</Card>
		);
	}
}


export default GroupAgentList;